import * as types from "../constants/ActionConstants"

export const setPointsGame = payload => ({
    type: types.GAME_CHANGE_POINTS,
    payload });

export const setUpdateTime = payload => ({
    type: types.GAME_CHANGE_TIME,
    payload
});

export const setStateGame = payload => ({
    type: types.GAME_STATE_GAME,
    payload
});

export const setStateHelp = payload => ({
    type: types.GAME_STATE_HELP,
    payload
});

export const setHelp = payload => ({
    type: types.GAME_HELP,
    payload
});



